import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import core from '@gin-betting/core';
import { createStructuredSelector } from 'reselect';

import { State } from 'types';

const { makeOddsByMarketSelector } = core.entities.selectors;
const { selectMarket } = core.entities.selectors;

interface Params {
    marketId: string;
}

const makePropsSelector = () => {
    const selectOdds = makeOddsByMarketSelector({
        marketSelector: selectMarket,
        propsToPick: ['id', 'name'],
    });

    return createStructuredSelector({ odds: selectOdds, market: selectMarket });
};

function useMarketTotal(params: Params): ReturnType<typeof selectProps> {
    const selectProps = useMemo(makePropsSelector, []);

    return useSelector<State, ReturnType<typeof selectProps>>(state =>
        selectProps(state, params)
    );
}

export default useMarketTotal;
